export default __webpack_public_path__ + "static/media/cal_bg2.1907e803.jpg";